import React from 'react'

const Pendentif = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/pendentif.svg" alt="pendentif"/>
  )
}

export default Pendentif